/****************************************************
 * Module Name:  mixClarityProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class MixClarityProxy {
  static GetAllClarity = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/clarity",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllClarityMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/clarity/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleClarity = (clarityId, callback) => {
    let params = {
      id: clarityId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/clarity",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckClarityAvailable = (clarity, callback) => {
    let params = {
      clarity: clarity,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/clarity/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddClarity = (clarity, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/clarity",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(clarity),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateClarity = (clarity, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/clarity",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(clarity),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
